import React, { useEffect } from 'react';
import { Gradient } from './gradient';
import './GradientCanvas.css';

/**
 * GradientCanvas — Stripe-style animated WebGL mesh gradient, tuned to the
 * Command Center palette (orange #FF6A00 / amber / blue / ink). Colors are read
 * from the --gradient-color-* CSS vars in GradientCanvas.css. Fails silently to
 * a transparent canvas if WebGL is unavailable.
 */
export default function GradientCanvas({ className = '' }) {
  useEffect(() => {
    // Bail out entirely if WebGL isn't available, so the vendored lib never
    // throws in its async render loop on unsupported browsers/devices.
    let supported = false;
    try {
      const test = document.createElement('canvas');
      supported = !!(test.getContext('webgl') || test.getContext('experimental-webgl'));
    } catch {
      supported = false;
    }
    if (!supported) return undefined;

    let gradient;
    const id = window.requestAnimationFrame(() => {
      try {
        gradient = new Gradient();
        gradient.initGradient('#vh-gradient-canvas');
      } catch {
        /* WebGL init failed — leave canvas transparent */
      }
    });
    return () => {
      window.cancelAnimationFrame(id);
      try {
        gradient && gradient.disconnect && gradient.disconnect();
      } catch {
        /* no-op */
      }
    };
  }, []);

  return <canvas id="vh-gradient-canvas" className={`vh-gradient-canvas ${className}`} aria-hidden="true" />;
}
